module.exports = __webpack_public_path__ + "img/food-certification.f5b5a482.png";